import { render, staticRenderFns } from "./qlk-import.vue?vue&type=template&id=831fb52a"
import script from "./qlk-import.vue?vue&type=script&lang=js"
export * from "./qlk-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports